/**
 * @generated SignedSource<<1b2127c482a0990fa7ea55cd1bd13729>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuyerPriceTableFormatStylesType = "DISCOUNT" | "%future added value";
export type BuyerPriceTableRowTypeType = "ADDITIONAL_CHARGE" | "AUCTION_SECOND_CHANCE_PRICE" | "AUSTRALIAN_GST" | "BUYER_DUTIES_TAX" | "BUY_IT_NOW_PRICE" | "COMPLIMENTARY_SHIPPING" | "CREDIT" | "CURRENT_BID_PRICE" | "CUSTOM_MOD" | "DEALER_SHIPMENT_REFUND" | "FIRSTDIBS_SHIPMENT_REFUND" | "ITEM_REFUND" | "LIST_PRICE" | "NEGOTIATED_DISCOUNT" | "PRICE" | "PRICE_DISCOUNT" | "PRICE_MOD" | "PROMO" | "PROMOTION" | "PUR_PRICE" | "QUANTITY" | "SALES_TAX" | "SHIPPING" | "SHIPPING_SUBSIDY" | "TOTAL" | "TOTAL_REFUND" | "TOTAL_SALES_TAX" | "WINNING_BID_PRICE" | "%future added value";
export type BuyerPriceTableType = "MAIN" | "REFUND" | "%future added value";
export type PartyRole = "BUYER" | "EXTERNAL" | "INTERNAL" | "LSP" | "SELLER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutTotals_transaction$data = {
  readonly buyerInvoice: {
    readonly totalSalesTax: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly buyerPriceTables: {
    readonly tables: ReadonlyArray<{
      readonly rows: ReadonlyArray<{
        readonly formatStyle: BuyerPriceTableFormatStylesType | null;
        readonly hasTopBorder: boolean | null;
        readonly label: string | null;
        readonly rowType: BuyerPriceTableRowTypeType | null;
        readonly subLabel: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly type: BuyerPriceTableType | null;
    } | null> | null;
  } | null;
  readonly canBeTaxExempt: boolean | null;
  readonly currentOrSubmittedOrNewShipmentQuote: {
    readonly author: {
      readonly role: PartyRole | null;
    } | null;
    readonly isShipmentSubsidized: boolean | null;
    readonly isShipmentSubsidizedByDibs: boolean | null;
    readonly serviceMethod: {
      readonly serviceType: string | null;
    } | null;
  } | null;
  readonly isNegotiable: boolean | null;
  readonly isShippingKnownAtCheckout: boolean | null;
  readonly isVatOrder: boolean | null;
  readonly isVatReverseChargeApplied: boolean | null;
  readonly priceBookName: string | null;
  readonly shipment: {
    readonly isShippingWithinUS: boolean | null;
  } | null;
  readonly summary: {
    readonly invoiceSummary: {
      readonly buyerCurrentInvoice: {
        readonly totalAmount: {
          readonly amount: number | null;
          readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormatAmount_financialAmount">;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_transaction" | "CheckoutSelectQuantity_transaction" | "CheckoutSidebarChargesDisclaimer_transaction" | "CheckoutTotalsDutiesMessage_transaction">;
  readonly " $fragmentType": "CheckoutTotals_transaction";
};
export type CheckoutTotals_transaction$key = {
  readonly " $data"?: CheckoutTotals_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTotals_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "displayCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTotals_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSelectQuantity_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarChargesDisclaimer_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotalsDutiesMessage_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShippingKnownAtCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Invoice",
      "kind": "LinkedField",
      "name": "buyerInvoice",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "totalSalesTax",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "displayCurrency",
          "variableName": "displayCurrency"
        }
      ],
      "concreteType": "BuyerPriceTables",
      "kind": "LinkedField",
      "name": "buyerPriceTables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BuyerPriceTable",
          "kind": "LinkedField",
          "name": "tables",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BuyerPriceTableRow",
              "kind": "LinkedField",
              "name": "rows",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formatStyle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasTopBorder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionSummaryObject",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceSummary",
          "kind": "LinkedField",
          "name": "invoiceSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Invoice",
              "kind": "LinkedField",
              "name": "buyerCurrentInvoice",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "totalAmount",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutFormatAmount_financialAmount"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeTaxExempt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVatOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVatReverseChargeApplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "kind": "LinkedField",
      "name": "currentOrSubmittedOrNewShipmentQuote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "kind": "LinkedField",
          "name": "serviceMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Party",
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "role",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShipmentSubsidizedByDibs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShipmentSubsidized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Shipment",
      "kind": "LinkedField",
      "name": "shipment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShippingWithinUS",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "22eac45e217923348026edb842c5d757";

export default node;
